
export class Iec {
    id_iec:number;
    titre_iec:any;
    description_iec:any;
    logo_iec : any;
    fichier_iec:any;
    date_iec:any;
    etat_iec:any;
    etat_epid:any;
          
    constructor(id_iec:number){
           
    }
}
